//トップページ　キービジュアルスライダー
import slick from "slick-carousel";

export function idxFunc() {
  let indexPage = $("#indexTop").length;
  let resizecheck = $("#responsibleCheck").width();

  $(window).on("resize", function () {
    resizecheck = $("#responsibleCheck").width();
  });

  if (indexPage) {
    const slideStart = function () {
      $(".slideArea2").each(function () {
        const $_t = $(this);

        if (resizecheck <= 1) {
          if ($_t.hasClass("slick-initialized")) {
            $_t.slick("unslick");
            $_t.off("beforeChange.mySlide afterChange.mySlide");
          }
          return;
        }

        if (!$_t.hasClass("slick-initialized")) {
          $_t.slick({
            autoplay: true,
            autoplaySpeed: 99000,
            speed: 400,
            slidesToShow: 1,
            arrows: true,
            dots: true,
            fade: false,
            infinite: true,
            pauseOnTouchMove: false,
            pauseOnHover: false,
            nextArrow: '<img src="/s/garrack/feature/ultraman2026/images/common/slide_arrows_next.svg" class="slide-arrow next-arrow">',
            prevArrow: '<img src="/s/garrack/feature/ultraman2026/images/common/slide_arrows_prev.svg" class="slide-arrow prev-arrow">',
          });

          // 初期表示処理
          const $initSlide = $_t.find(".slick-slide.slick-current");
        }

        // dotsのliにクラス付与
        $_t.find(".slick-dots li").each(function (index) {
          $(this).addClass("dot-" + (index + 1));
        });
      });
    };

    slideStart();

    let setTimer = false;
    $(window).on("resize", function () {
      if (setTimer) clearTimeout(setTimer);
      setTimer = setTimeout(() => {
        slideStart();
      }, 200);
    });
  }

   $(window).on("resize", function () {
    resizecheck = $("#responsibleCheck").width();
  });

  if (indexPage) {
    const slideStart = function () {
      $(".slideArea").each(function () {
        const $_t = $(this);

        if (resizecheck <= 1) {
          if ($_t.hasClass("slick-initialized")) {
            $_t.slick("unslick");
            $_t.off("beforeChange.mySlide afterChange.mySlide");
          }
          return;
        }

        if (!$_t.hasClass("slick-initialized")) {
          $_t.slick({
            autoplay: true,
            autoplaySpeed: 99000,
            speed: 400,
            slidesToShow: 3,
            arrows: true,
            dots: true,
            fade: false,
            infinite: true,
            pauseOnTouchMove: false,
            pauseOnHover: false,
            centerMode: true,
            centerPadding: "0px",
            variableWidth: true,
            nextArrow: '<img src="/s/garrack/feature/ultraman2026/images/common/slide_arrows_next.svg" class="slide-arrow next-arrow">',
            prevArrow: '<img src="/s/garrack/feature/ultraman2026/images/common/slide_arrows_prev.svg" class="slide-arrow prev-arrow">',
          });

          // 初期表示処理
          const $initSlide = $_t.find(".slick-slide.slick-current");
        }

        // dotsのliにクラス付与
        $_t.find(".slick-dots li").each(function (index) {
          $(this).addClass("dot-" + (index + 1));
        });
      });
    };

    slideStart();

    let setTimer = false;
    $(window).on("resize", function () {
      if (setTimer) clearTimeout(setTimer);
      setTimer = setTimeout(() => {
        slideStart();
      }, 200);
    });
  }
}
